import React from 'react';
import ContentLoader from 'react-content-loader';

const ChainSkeleton = props => (
  <ContentLoader
    speed={2}
    width={260}
    height={65}
    viewBox="0 0 260 65"
    backgroundColor="#e6e6e6"
    foregroundColor="#ffffff"
    uniqueKey="chain-skeleton"
    {...props}
  >
    <rect x="30" y="0" rx="3" ry="3" width="170" height="17" />
    <rect x="30" y="24" rx="3" ry="3" width="110" height="10" />
    <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
    <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
    <circle cx="9" cy="9" r="9" />
    <rect x="30" y="41" rx="3" ry="3" width="126" height="10" />
  </ContentLoader>
);

export default ChainSkeleton;
